import { Button, BUTTON_TYPE, COLORS, FONT_FAMILY_SEMIBOLD, RadioButton } from '@dehaat/dds';
import { FULFILLMENT_TYPE } from '@dehaat/kisan-app-bl/models/Vendor';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import CurrentLocation from '@/components/navigation/CurrentLocation';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import Spinner from '@/components/Spinner';
import SubHeading from '@/components/SubHeading';
import { COOKIE_MAX_AGE_1YEAR, CURRENT_VENDOR_KEY, FeedTabs, VENDOR_ID_COOKIE_NAME } from '@/constants/common';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { selectCurrentVendorId, selectLoadingHyperlocalData, selectVendorsList, setCurrentVendor } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import { setLocalStorageKey } from '@/utils/helper';
const DcsPage = () => {
  const {
    t
  } = useTranslation('nearbyDc');
  const {
    push,
    replace,
    query,
    back
  } = useRouter();
  const vendorList = useAppSelector(selectVendorsList);
  const isHyperlocalDataLoading = useAppSelector(selectLoadingHyperlocalData);
  const currentVendorId = useAppSelector(selectCurrentVendorId);
  const dispatch = useAppDispatch();
  const [selectedVendor, setSelectedVendor] = useState(0);
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const getRadioItems = useCallback(() => {
    const radioElements: Array<{
      radioElement: ReactElement;
      value: string | number;
    }> = [];
    vendorList.map(({
      company_address,
      company_name,
      distance,
      id,
      fulfillment_type
    }, index) => {
      const item = {
        radioElement: <div key={index}>
              <SubHeading>{company_name}</SubHeading>
              <p className="mt-1 text-neutral-90 text-sm">{company_address}</p>
              <p className="mt-1 text-neutral-90 text-sm">
                {t('distance')}{' '}
                <span className="font-nato-semibold">
                  {Math.floor(distance)} {t('km')}
                </span>
              </p>
              <div className="mt-3 px-3 py-2 rounded-xl w-fit text-[10px] text-white" style={{
            backgroundColor: fulfillment_type === FULFILLMENT_TYPE.DOORSTEP_DELIVERY ? COLORS.blue100 : COLORS.mulberry100,
            font: FONT_FAMILY_SEMIBOLD
          }}>
                {t(`${fulfillment_type.toLowerCase()}`)}
              </div>
            </div>,
        value: id as number
      };
      radioElements.push(item);
    });
    return radioElements;
  }, [vendorList, t]);
  useEffect(() => {
    vendorList.forEach((dc, index) => {
      if (dc.id.toString() === currentVendorId) {
        setSelectedVendor(index);
        return;
      }
    });
  }, [currentVendorId, vendorList]);
  return <main className="relative bg-neutral-10" data-sentry-component="DcsPage" data-sentry-source-file="dcs.tsx">
      <HeaderWithBackButton homePath={`/?tab=${FeedTabs.SHOP}`} heading={t('dehaat_centers')} onBackClick={back} data-sentry-element="HeaderWithBackButton" data-sentry-source-file="dcs.tsx" />

      <section className="m-auto pt-16 w-full max-w-7xl min-h-screen">
        <div className="flex justify-between items-center bg-white p-4">
          <CurrentLocation data-sentry-element="CurrentLocation" data-sentry-source-file="dcs.tsx" />

          <Button buttonStyle={{
          backgroundColor: COLORS.primary10,
          paddingHorizontal: 16,
          paddingVertical: 4
        }} onClick={() => {
          trackCustomEvent(CustomEventTypes.VENDOR_CHANGE_BUTTON_CLICKED);
          push('/location');
        }} type={BUTTON_TYPE.SECONDARY} text={t('change')} data-sentry-element="Button" data-sentry-source-file="dcs.tsx" />
        </div>

        {vendorList.length > 0 ? <div className="bg-white mt-2 p-4 min-h-screen">
            <SubHeading>
              {t('nearest')} {t('dehaat_centers')}
            </SubHeading>
            <RadioButton containerStyle={{
          gap: 16,
          borderWidth: 1,
          borderColor: COLORS.neutral10,
          borderRadius: 12,
          paddingHorizontal: 20,
          paddingVertical: 16
        }} list={getRadioItems()} onClick={index => {
          document.cookie = `${VENDOR_ID_COOKIE_NAME}=${vendorList[index].id}; max-age=${COOKIE_MAX_AGE_1YEAR}; path=/`;
          setLocalStorageKey(CURRENT_VENDOR_KEY, vendorList[index]);
          dispatch(setCurrentVendor(vendorList[index]));
          setSelectedVendor(index);
          trackCustomEvent(CustomEventTypes.VENDOR_SELECTED, JSON.stringify({
            Selected_Vendor_Name: vendorList[index].company_name,
            Selected_Vendor_Id: vendorList[index].id
          }));
          replace({
            pathname: `/`,
            query: {
              ...query,
              tab: '2'
            }
          });
        }} selected={selectedVendor} selectedRadioContainerStyle={{
          borderColor: COLORS.primary100
        }} />
          </div> : isHyperlocalDataLoading ? <Spinner /> : <Paragraph className="bg-error-10 mt-4 px-4 py-3 border border-error-110 rounded-lg" isHighlighted variant={VARIANT.MEDIUM}>
            {t('no_dc')}
          </Paragraph>}
      </section>
    </main>;
};
export default DcsPage;